import { createContext, useContext } from "react";
import { PatientRecord } from "./api_types";

export const CurrentPatientContext = createContext<PatientRecord | null>(null);

export const useCurrentPatientContext = () => useContext(CurrentPatientContext);
